import { render, staticRenderFns } from "./mobile_forgetPassword.vue?vue&type=template&id=4448debc&scoped=true"
import script from "./mobile_forgetPassword.vue?vue&type=script&lang=js"
export * from "./mobile_forgetPassword.vue?vue&type=script&lang=js"
import style0 from "./mobile_forgetPassword.vue?vue&type=style&index=0&id=4448debc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4448debc",
  null
  
)

export default component.exports